import {
  AppBar,
  Box,
  CircularProgress,
  Divider,
  Grid,
  Toolbar,
  Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/styles'
import AppIcon from '../../../commonComponents/AppIcon'
import { TextRegular } from '../../../commonComponents/TextStyling'

import { isEmpty, showToast } from '../../../utils/AppHelper'
import { useLocation, useNavigate } from 'react-router-dom'
import serverData from '../../../api/ServerData'
import { paddingHorizontal, paddingVertical } from '../../../utils/AppConstants'
import RecruiterFeedback from './RecruiterFeedback'
import Completed from './Completed'
import JobDetails from './JobDetails'
import UpdateProfile from './UpdateProfile'

export default function ApproveCandidate () {
  const [state, setState] = useState(1)

  const location = useLocation()
  const navigate = useNavigate()
  const [error, setError] = useState(false)

  const [loading, setLoading] = useState(true)

  const [candidateState, setCandidateState] = useState(null)

  const query = new URLSearchParams(location.search)
  const token = query.get('token')

  useEffect(function () {
    if (isEmpty(token)) {
      setError(true)
    } else {
      getCandidateDetails()
    }
  }, [])

  function getCandidateDetails () {
    setLoading(true)
    serverData.getJobDetailsForCandidate(
      { token },
      data => {
        if (data?.status) {
          setCandidateState(data?.response)
        } else {
          navigate('/')
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        showToast(error.statusText)
      }
    )
  }

  var theme = useTheme()

  const stages = [
    { label: 'Approved', step: 1 },
    { label: 'Update your profile', step: 2 },
    {
      label: 'Recruiter information',
      step: 3
    }
  ]

  return (
    <div
      container
      style={{
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          height: '110px'
        }}
      >
        <AppBar
          sx={{
            bgcolor: theme.palette.background.paper,
            borderBottom: `1px solid ${theme.palette.border.main}`
          }}
          elevation={0}
        >
          <Toolbar
            style={{
              height: '75px',
              paddingLeft: '15px',
              paddingRight: '15px',

              justifyContent: 'space-between'
            }}
          >
            <AppIcon style={{ width: 90, height: 'auto' }} />
            <div
              style={{
                width: '40%'
              }}
            >
              <Divider
                sx={{
                  position: 'relative',
                  top: '20px',
                  left: '18%',
                  zIndex: 0,
                  width: '65%',
                  borderBottomWidth: 'medium'
                }}
              />
              <div
                style={{
                  display: 'flex'
                }}
              >
                {stages.map((item, index) => (
                  <Box
                    key={index}
                    textAlign={'center'}
                    flex={1}
                    position={'relative'}
                  >
                    <Typography variant='body1' marginTop={'8px'}>
                      <Box
                        width={25}
                        height={25}
                        borderRadius={'50%'}
                        backgroundColor={
                          state === item.step
                            ? theme.palette.primary.main
                            : theme.palette.background.default
                        }
                        border={
                          state === item.step
                            ? `1px solid ${theme.palette.primary.main}`
                            : `3px solid ${theme.palette.background.default}`
                        }
                        color={
                          state === item.step
                            ? theme.palette.text.opposite
                            : theme.palette.text.primary
                        }
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        margin={'0px auto'}
                        style={{ position: 'relative', zIndex: 1 }}
                      >
                        {item.step}
                      </Box>
                    </Typography>
                    <Typography
                      variant='body2'
                      marginTop={'8px'}
                      color={theme.palette.text.primary}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                ))}
              </div>
            </div>
            <div style={{ width: '10%' }} />
          </Toolbar>
        </AppBar>
      </div>

      <div
        style={{
          height: `calc(100% - 110px)`,
          overflow: 'auto',
          padding: `0px 15px`
        }}
      >
        {error ? (
          <h2 style={{ textAlign: 'center' }}>Invalid Request</h2>
        ) : loading ? (
          <Grid
            container
            spacing={2}
            direction={'column'}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '70vh',
              width: '100%'
            }}
          >
            <Grid item>
              <CircularProgress />
            </Grid>
            <Grid item>
              <TextRegular>Searching...</TextRegular>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {!isEmpty(candidateState) ? (
              <Grid
                item
                xs={12}
                style={{
                  background: theme.palette.background.paper,
                  borderRadius: '16px',
                  padding: 24
                }}
              >
                {state === 1 ? (
                  <JobDetails
                    candidateState={candidateState}
                    changeState={setState}
                  />
                ) : state === 2 ? (
                  <UpdateProfile
                    candidateState={candidateState}
                    changeState={setState}
                    getCandidateDetails={getCandidateDetails}
                  />
                ) : state === 3 ? (
                  <RecruiterFeedback
                    candidateState={candidateState}
                    changeState={setState}
                  />
                ) : state === 4 ? (
                  <Completed candidateState={candidateState} />
                ) : null}
              </Grid>
            ) : (
              <h2 style={{ textAlign: 'center' }}>
                Oops!!
                <br />
                Something went wrong...
              </h2>
            )}
          </Grid>
        )}
      </div>
    </div>
  )
}
